import React from 'react';

function SupplierTabs({ supplier }) {
  // Ensure website URL starts with http/https
  const websiteUrl = supplier.website
    ? supplier.website.startsWith('http')
      ? supplier.website
      : `https://${supplier.website}`
    : '';

  return (
    <div className="container py-4">
      <ul className="nav nav-tabs supplier-tab-nav mb-3" id="supplierTab" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className="nav-link active"
            id="overview-tab"
            data-bs-toggle="tab"
            data-bs-target="#overview"
            type="button"
            role="tab"
            aria-controls="overview"
            aria-selected="true"
          >
            Overview
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="address-tab"
            data-bs-toggle="tab"
            data-bs-target="#address"
            type="button"
            role="tab"
            aria-controls="address"
            aria-selected="false"
          >
            Address
          </button>
        </li>
      </ul>

      <div className="tab-content supplier-tab-content" id="supplierTabContent">
        {/* Overview Tab */}
        <div
          className="tab-pane fade show active"
          id="overview"
          role="tabpanel"
          aria-labelledby="overview-tab"
        >
          <h5>Overview</h5>
          <p><strong>Company Name:</strong> {supplier.supplier_name}</p>
          <p><strong>Contact Person:</strong> {supplier.contact_person}</p>
          <p><strong>We Are Providers of:</strong> {supplier.providers_of}</p>
        </div>

        {/* Address Tab */}
        <div
          className="tab-pane fade"
          id="address"
          role="tabpanel"
          aria-labelledby="address-tab"
        >
          <h5>Address</h5>
          <p><strong>Street:</strong> {supplier.address}</p>
          <p><strong>City:</strong> {supplier.city}</p>
          <p><strong>State:</strong> {supplier.state}</p>
          <p><strong>Pin Code:</strong> {supplier.pincode}</p>
          <p><strong>Contact:</strong> {supplier.mobile_no || supplier.phone_no}</p>
          <p><strong>Email:</strong> {supplier.email}</p>
          {supplier.website && (
            <p>
              <strong>Website:</strong>{' '}
              <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
                {supplier.website}
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SupplierTabs;
